function BasketItem(props) {
  const {
		displayName = '',
		price = 0,
		quantity = 0,
		deleteFromBasket = Function.prototype,
		incrementItem = Function.prototype,
		decrementItem = Function.prototype,
		mainId = '',
		offerId = '',
  } = props;
  const itemPrice = price?.finalPrice;
  console.log('quantity basket', quantity)

  return (
		<li className='collection-item'>
			<span className='basket-item-element'>
				{displayName} x {quantity} = {itemPrice}
			</span>
			<i
				class='material-icons tiny item-remove basket-item-element item-hover'
				onClick={() => decrementItem(mainId, offerId)}
			>
				remove_circle_outline
			</i>
			<i
				class='material-icons tiny item-add basket-item-element item-hover'
				onClick={() => incrementItem(mainId, offerId)}
			>
				add_circle_outline
			</i>
			<span class='secondary-content'>
				<i
					class='material-icons item-hover basket-item-element'
					onClick={() => deleteFromBasket(mainId, offerId)}
				>
					close
				</i>
			</span>
		</li>
  );
}

export { BasketItem };